module.exports = __webpack_public_path__ + "img/wf-finishing-position-26.66a312b2.svg";